// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import ElementUI from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import 'vuetify/dist/vuetify.min.css'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import * as Sentry from '@sentry/browser'
import vuetify from './plugins/vuetify'
import './plugins/vuetifyToast'
import './plugins/mobilize'
import * as VueGoogleMaps from 'vue2-google-maps'

import './firebase'

import config from './config'

window.axios = require('axios')
// window.axios.defaults.baseURL = '/static/dummy-data/'
window.axios.defaults.baseURL = 'https://graph.facebook.com/v8.0/'

Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  }
})
Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(VueMomentJS, moment)
locale.use(lang)
Vue.use(VueHighcharts, { Highcharts })
Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleMaps.apiKey,
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then set installComponents to 'false'.
  // If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

Sentry.init({
  ...config.sentry,
  integrations: [new Sentry.Integrations.Vue({ Vue })]
})

Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
  console.log(err)
  Sentry.captureException(err)
}
/* eslint-disable no-new */
new Vue({
  router,
  store,
  components: { App },
  vuetify,
  template: '<App/>',
  render: h => h(App)
}).$mount('#app')
